import { LegalPage, LegalSection } from "../components/v2/LegalPage";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" updated="31 JULY 2026" testId="privacy-page">
      <p>
        Sourcecode (“we”, “us”, or “the app”) is a personal insight application
        that generates a personal rhythm baseline and daily readings based on
        information you provide.
      </p>

      <LegalSection heading="What information we collect">
        <p>When you use Sourcecode, we may collect:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Your name</li>
          <li>Date of birth</li>
          <li>Time of birth (if provided)</li>
          <li>Place of birth (city/country and the coordinates derived from it)</li>
          <li>Information about people you choose to add (name, birth details, relationship type)</li>
          <li>Messages you send in the ASK feature</li>
          <li>Basic device and usage information needed to run the app</li>
          <li>Purchase and subscription information (handled by Apple and RevenueCat)</li>
        </ul>
        <p>
          Most of your personal data stays on your device. We do not require an
          account to use the core features of the app.
        </p>
      </LegalSection>

      <LegalSection heading="How we use your information">
        <p>We use the information you provide to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Calculate your rhythm baseline and today's timing</li>
          <li>Generate daily readings and insights</li>
          <li>Power the ASK feature</li>
          <li>Show compatibility information for people you add</li>
          <li>Process subscriptions and restore purchases</li>
        </ul>
      </LegalSection>

      <LegalSection heading="AI processing">
        <p>
          Some insights are generated with the help of an AI service. When this
          happens, we only send the already-calculated timing data (for
          example, your baseline values and today's scores). We do not send your
          raw birth details to the AI service.
        </p>
      </LegalSection>

      <LegalSection heading="Third-party services">
        <p>We use the following third-party services:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Apple (App Store, payments, and device services)</li>
          <li>RevenueCat (subscription management)</li>
          <li>An AI provider (for generating written insights)</li>
        </ul>
        <p>
          These services only receive the minimum information required to
          perform their function.
        </p>
      </LegalSection>

      <LegalSection heading="Data storage and security">
        <ul className="list-disc pl-6 space-y-2">
          <li>Baseline data, readings, and messages are primarily stored on your device.</li>
          <li>We take reasonable steps to protect information that leaves your device.</li>
          <li>We do not sell your personal information.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Data retention">
        <p>
          Data stored on your device remains there until you delete the app or
          clear the data. We do not currently operate long-term cloud accounts.
        </p>
      </LegalSection>

      <LegalSection heading="Your rights">
        <p>
          Depending on where you live, you may have rights to access, correct,
          or delete personal information we hold. Because most data lives on
          your device, deleting the app removes the majority of your
          information.
        </p>
      </LegalSection>

      <LegalSection heading="Children">
        <p>
          Sourcecode is not intended for children under 17. We do not knowingly
          collect information from children.
        </p>
      </LegalSection>

      <LegalSection heading="Changes to this policy">
        <p>
          We may update this Privacy Policy from time to time. The latest
          version will always be available at this page.
        </p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>
          If you have questions about this Privacy Policy, contact us at{" "}
          <a
            href="mailto:b@psyanima.com"
            className="text-[#EC8C3C] hover:text-[#F4F1EC] transition-colors"
            data-testid="privacy-contact-email"
          >
            b@psyanima.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
}
